<template>
  <div class="c-home">
    <main-menu ref="menu" />
    <hero ref="hero" />
    <product-list
      id="products"
      :data="articleData"
      @emitOnEnter="stickHeroThere"
      @emitOnLeave="releaseHero"
    ></product-list>
    <sm-event
      triggerHook="0.05"
      @onEnter="onEnter"
      @onLeave="onLeave"
    ></sm-event>
    <section-about id="about"></section-about>
    <sm-event
      triggerHook="0.05"
      @onEnter="onThoughtEnter"
      @onLeave="onThoughtLeave"
    ></sm-event>
    <section-blog id="thought" :data="blogData"></section-blog>
    <sm-event
      triggerHook="0.05"
      @onEnter="onContactEnter"
    ></sm-event>
    <section-form id="contact"></section-form>
    <footer-container></footer-container>
    <plv-pointer/>
  </div>
</template>

<script>
import PlvPointer from '@/components/PlvPointer'
import Hero from '@/components/Hero'
import SectionAbout from '@/views/SectionAbout'
import SectionBlog from '@/views/SectionBlog'
import SectionForm from '@/views/SectionForm'
import ProductList from '@/components/ProductList'
import MainMenu from '@/components/MainMenu'
import FooterContainer from '@/components/FooterContainer'

let homeTopPosition = 0

export default {
  metaInfo: {
    titleTemplate: 'YUYAMA DESIGN INC. | ブランディング&デザイン | デザインコンサルティング'
  },
  components: {
    PlvPointer,
    Hero,
    MainMenu,
    ProductList,
    FooterContainer,
    SectionAbout,
    SectionBlog,
    SectionForm
  },
  data () {
    return {
      logoStyleTop: undefined
    }
  },
  methods: {
    onEnter (event) {
      this.$refs.menu.updateCurrentMenu('about')
    },
    onLeave (event) {
      if (event.scrollDirection === 'FORWARD') {
        this.$refs.menu.updateCurrentMenu('about')
      } else {
        this.$refs.menu.updateCurrentMenu()
      }
    },
    onThoughtEnter (event) {
      if (event.scrollDirection === 'FORWARD') {
        this.$refs.menu.updateCurrentMenu('thought')
      } else {
        this.$refs.menu.updateCurrentMenu('thought')
      }
    },
    onThoughtLeave (event) {
      if (event.scrollDirection === 'REVERSE') {
        this.$refs.menu.updateCurrentMenu('about')
      }
    },
    onContactEnter (event) {
      this.$refs.menu.updateCurrentMenu('contact')
    },
    // event delivered from child
    stickHeroThere (target) {
      const productLMposY = this.getElementYPosition(target)
      if (window.innerWidth > this.$store.state.mq.md) {
        this.$refs.hero.$el.style.position = 'absolute'
        this.$refs.hero.$el.style.top = productLMposY + 'px'
      }
    },
    // event delivered from child
    releaseHero (target) {
      if (window.innerWidth > this.$store.state.mq.md) {
        this.$refs.hero.$el.style.position = 'fixed'
        this.$refs.hero.$el.style.top = 0
      }
    }
  },
  computed: {
    blogData () {
      return this.$store.state.BlogArticle.articles
    },
    articleData () {
      return this.$store.state.ProductArticle.articles
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      document.documentElement.scrollTop = homeTopPosition
    })
  },
  beforeRouteUpdate (to, from, next) {
    next()
  },
  beforeRouteLeave (to, from, next) {
    homeTopPosition = document.documentElement.scrollTop
    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue